/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Widget for No Content Found
 */
// TODO

import { Empty } from 'antd';
import { EMPTY_MESSAGE, LOADING_MESSAGE } from 'app-constants/eligibility';

interface IProps {
	loading?: boolean;
}

/**
 * NoContentFound
 * @param {IProps} props
 * @returns {React.FC} NoContentFound
 */
const NoContentFound: React.FC<IProps> = ({ loading }) => {
	if (loading) {
		return <div>{LOADING_MESSAGE}</div>;
	}
	return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_MESSAGE} />;
};

export default NoContentFound;
